export const PAGE_LIST = {
  NEWS: { 'en-US': 'news', fr: 'actualites' },
  AGENCY: { 'en-US': 'agency', fr: 'agence' },
  CONTACT: { 'en-US': 'contact-us', fr: 'contact' },
  PROJECTS: { 'en-US': 'projects', fr: 'projets' },
};

export const PAGE_LIST_ARRAY = Object.values(PAGE_LIST);
